import { render } from "./Card.vue?vue&type=template&id=3df0590c&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=3df0590c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3df0590c"

export default script